import {LogoMarquee, type LogoMarqueeProps} from '../../generic/LogoMarquee/LogoMarquee'
import {Testimonials, type TestimonialsProps} from '../../generic/Testimonials/Testimonials'
import Styles from './TestimonialsSection.module.css'

export interface TestimonialsSectionProps {
  data: TestimonialsProps
  logoMarquee: LogoMarqueeProps
}

export const defaultProps: Partial<TestimonialsSectionProps> = {}

export const TestimonialsSection = (props: TestimonialsSectionProps) => {
  const initializedProps: TestimonialsSectionProps = {...defaultProps, ...props}
  const {data, logoMarquee} = initializedProps

  return (
    <div className={Styles['TestimonialsSection']}>
      <Testimonials {...data} />
      <LogoMarquee {...logoMarquee} />

      <div className={Styles['TestimonialsSection__Spacer']} />
    </div>
  )
}
